export default __webpack_public_path__ + "static/media/fogWCr.51bd8afa.webp";